// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  UsageComparisonResponse,
  UsageComparisonResponseT,
  verifyUsageComparisonResponse,
} from "./usage-comparison-response";

export class UsageComparisonResponses implements flatbuffers.IUnpackableObject<UsageComparisonResponsesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UsageComparisonResponses {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUsageComparisonResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageComparisonResponses,
  ): UsageComparisonResponses {
    return (obj || new UsageComparisonResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsUsageComparisonResponses(
    bb: flatbuffers.ByteBuffer,
    obj?: UsageComparisonResponses,
  ): UsageComparisonResponses {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UsageComparisonResponses()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  results(index: number, obj?: UsageComparisonResponse): UsageComparisonResponse | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new UsageComparisonResponse()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  resultsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startUsageComparisonResponses(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addResults(builder: flatbuffers.Builder, resultsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, resultsOffset, 0);
  }

  static createResultsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startResultsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endUsageComparisonResponses(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // results
    return offset;
  }

  static createUsageComparisonResponses(
    builder: flatbuffers.Builder,
    resultsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    UsageComparisonResponses.startUsageComparisonResponses(builder);
    UsageComparisonResponses.addResults(builder, resultsOffset);
    return UsageComparisonResponses.endUsageComparisonResponses(builder);
  }

  unpack(): UsageComparisonResponsesT {
    return new UsageComparisonResponsesT(
      this.bb!.createObjList<UsageComparisonResponse, UsageComparisonResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      ),
    );
  }

  unpackTo(_o: UsageComparisonResponsesT): void {
    _o.results = this.bb!.createObjList<UsageComparisonResponse, UsageComparisonResponseT>(
      this.results.bind(this),
      this.resultsLength(),
    );
  }

  unpackFields(...fields: string[]): UsageComparisonResponsesT {
    const t = new UsageComparisonResponsesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("results")) {
      t.results = this.bb!.createObjList<UsageComparisonResponse, UsageComparisonResponseT>(
        this.results.bind(this),
        this.resultsLength(),
      );
    }
    return t;
  }
}

export class UsageComparisonResponsesT implements flatbuffers.IGeneratedObject {
  constructor(public results: UsageComparisonResponseT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.results === null || this.results === undefined) {
      throw new Error('Required field "results" is not set');
    }
    const results = UsageComparisonResponses.createResultsVector(
      builder,
      builder.createObjectOffsetList(this.results),
    );

    return UsageComparisonResponses.createUsageComparisonResponses(builder, results);
  }

  clone(): UsageComparisonResponsesT {
    const obj = new UsageComparisonResponsesT();
    obj.results = this.results.map((e) => e.clone());
    return obj;
  }

  equals(other: UsageComparisonResponsesT): boolean {
    if (this.results.length !== other.results.length) return false;
    for (let i = 0; i < this.results.length; i++) {
      const a = this.results[i];
      const b = other.results[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyUsageComparisonResponses(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUsageComparisonResponse);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "results");
  } finally {
    verifier.popDepth();
  }
}
